import { useContext } from 'react';

import { RolesAndPermissionsContext } from 'context/RolesAndPermissionsContext';

import { DEFAULT_PERMISSIONS } from 'constants/roles-and-permissions';

import { User } from 'types';

interface CanUserProps  {
    type: keyof typeof DEFAULT_PERMISSIONS,
    reverse?: boolean,
    customList?: string | string[],
    user?: User,
    children: React.ReactNode
}

const CanUser = ({ type, reverse, customList, user, children }: CanUserProps) => {
    const rolesAndPermissions = useContext(RolesAndPermissionsContext);

    const testResult = rolesAndPermissions?.canUser(type, customList, user);

    if (testResult && !reverse) {
        return <>{ children }</>;
    }

    if (!testResult && reverse) {
        return <>{ children }</>;
    }

    return null;
}

export default CanUser;
